import { render } from "./Footer.vue?vue&type=template&id=3d5632bb"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=3d5632bb&lang=scss"
script.render = render

export default script